import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipeModule, PreprocessFilePipeModule } from '@telespot/shared/util';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OsdZoomControllerComponent } from './components/osd-zoom-controller/osd-zoom-controller.component';
import { SampleReferenceStripComponent } from './components/sample-reference-strip/sample-reference-strip.component';
import { VideoViewerComponent } from './components/video-viewer/video-viewer.component';
import { MediaSourceSelectionComponent } from './components/media-source-selection/media-source-selection.component';
import { VideoRoisViewerDirective } from './directives/video-rois-viewer.directive';
import { VideoRoisDrawerDirective } from './directives/video-rois-drawer.directive';
import { VideoTrackPanelDirective } from './directives/video-trackPanel.directive';

@NgModule({
  declarations: [
    VideoViewerComponent,
    MediaSourceSelectionComponent,
    SampleReferenceStripComponent,
    OsdZoomControllerComponent,
    VideoRoisViewerDirective,
    VideoRoisDrawerDirective,
    VideoTrackPanelDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    DurationPipeModule,
    MatTooltipModule,
    PreprocessFilePipeModule,
    MatBadgeModule,
    MatSliderModule,
    ScrollingModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    SampleReferenceStripComponent,
    VideoViewerComponent,
    OsdZoomControllerComponent,
    VideoRoisViewerDirective,
    VideoRoisDrawerDirective,
    VideoTrackPanelDirective,
  ],
  providers: [],
})
export class ViewersFeatureModule {}
